import {Injectable} from '@angular/core';
import {ExceptionHandlerService} from '../../services/exception-handler-service';
import {Exception} from '../exception';
import {DialogService} from '../../services/dialog.service';

@Injectable()
export class GoneExceptionHandler extends ExceptionHandlerService {

  constructor(private readonly dialogService: DialogService) {
    super();
  }

  protected handle(exception: Exception): void {
    const reason: string | undefined = exception.clientException?.details?.deletionReason;
    let subject: string;
    let body: string;

    if (reason === 'COMPLETION') {
      subject = 'exceptions.gone.modal.completed.subject';
      body = 'exceptions.gone.modal.completed.body';
    } else if (reason === 'EXPIRATION') {
      subject = 'exceptions.gone.modal.expired.subject';
      body = 'exceptions.gone.modal.expired.body';
    } else if (reason === 'UNRELEASED' || reason === 'INACTIVITY') {
      subject = 'exceptions.gone.modal.inactive.subject';
      body = 'exceptions.gone.modal.inactive.body';
    } else if (reason === 'USER_DELETION' || reason === 'API_DELETION') {
      subject = 'exceptions.gone.modal.manuallyDeleted.subject';
      body = 'exceptions.gone.modal.manuallyDeleted.body';
    } else {
      subject = 'exceptions.gone.modal.fallback.subject';
      body = 'exceptions.gone.modal.fallback.body';
    }

    this.dialogService.openExceptionDialog({
      data: {title: subject, message: body}
    });
  }

  isResponsible(httpError: any): boolean {
    return httpError.status === 410;
  }
}
